import type { ApplicationConfig } from '@angular/core';

import { provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideLottieOptions } from 'ngx-lottie';

import { routes } from './app.routes';
import { authTokenInterceptor } from './core/interceptors/auth-token.interceptor';
import { errorStatusInterceptor } from './core/interceptors/error-status.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    // Hydration del cliente con SSR. withNoHttpTransferCache evita que las
    // respuestas HTTP del servidor se repliquen al navegador; las rutas
    // privadas requieren autenticación y deben volver a cargar sus datos.
    provideClientHydration(withNoHttpTransferCache()),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideHttpClient(
      withFetch(),
      withInterceptors([authTokenInterceptor, loadingInterceptor, errorStatusInterceptor]),
    ),
  ],
};
